export default __webpack_public_path__ + "static/media/placeholder_private01-es-web.9d9ea4d4.png";